export const LLM_SUPPORTED_FILETYPES = ["txt", "pdf", "json", "docx", "doc", "csv", "pptx"]
export const LLM_MAX_FILESIZE = 50 * 1024 * 1024 // 50MB
export const LLM_MAX_FILES = 10
